import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 7.25C7.77614 7.25 8 7.47386 8 7.75C8 8.02614 7.77614 8.25 7.5 8.25H1.5C1.22386 8.25 1 8.02614 1 7.75C1 7.47386 1.22386 7.25 1.5 7.25H7.5ZM10.5 3.75C10.7761 3.75 11 3.97386 11 4.25C11 4.52614 10.7761 4.75 10.5 4.75H1.5C1.22386 4.75 1 4.52614 1 4.25C1 3.97386 1.22386 3.75 1.5 3.75H10.5Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99992 9.66667C10.3681 9.66667 10.6666 9.96514 10.6666 10.3333C10.6666 10.7015 10.3681 11 9.99992 11H1.99992C1.63173 11 1.33325 10.7015 1.33325 10.3333C1.33325 9.96514 1.63173 9.66667 1.99992 9.66667H9.99992ZM13.9999 5C14.3681 5 14.6666 5.29848 14.6666 5.66667C14.6666 6.03486 14.3681 6.33333 13.9999 6.33333H1.99992C1.63173 6.33333 1.33325 6.03486 1.33325 5.66667C1.33325 5.29848 1.63173 5 1.99992 5H13.9999Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5001 12.0833C12.9603 12.0833 13.3334 12.4564 13.3334 12.9167C13.3334 13.3769 12.9603 13.75 12.5001 13.75H2.50008C2.03984 13.75 1.66675 13.3769 1.66675 12.9167C1.66675 12.4564 2.03984 12.0833 2.50008 12.0833H12.5001ZM17.5001 6.25C17.9603 6.25 18.3334 6.6231 18.3334 7.08333C18.3334 7.54357 17.9603 7.91667 17.5001 7.91667H2.50008C2.03984 7.91667 1.66675 7.54357 1.66675 7.08333C1.66675 6.6231 2.03984 6.25 2.50008 6.25H17.5001Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 7.25C7.77614 7.25 8 7.47386 8 7.75C8 8.02614 7.77614 8.25 7.5 8.25H1.5C1.22386 8.25 1 8.02614 1 7.75C1 7.47386 1.22386 7.25 1.5 7.25H7.5ZM10.5 3.75C10.7761 3.75 11 3.97386 11 4.25C11 4.52614 10.7761 4.75 10.5 4.75H1.5C1.22386 4.75 1 4.52614 1 4.25C1 3.97386 1.22386 3.75 1.5 3.75H10.5Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99992 9.66667C10.3681 9.66667 10.6666 9.96514 10.6666 10.3333C10.6666 10.7015 10.3681 11 9.99992 11H1.99992C1.63173 11 1.33325 10.7015 1.33325 10.3333C1.33325 9.96514 1.63173 9.66667 1.99992 9.66667H9.99992ZM13.9999 5C14.3681 5 14.6666 5.29848 14.6666 5.66667C14.6666 6.03486 14.3681 6.33333 13.9999 6.33333H1.99992C1.63173 6.33333 1.33325 6.03486 1.33325 5.66667C1.33325 5.29848 1.63173 5 1.99992 5H13.9999Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5001 12.0833C12.9603 12.0833 13.3334 12.4564 13.3334 12.9167C13.3334 13.3769 12.9603 13.75 12.5001 13.75H2.50008C2.03984 13.75 1.66675 13.3769 1.66675 12.9167C1.66675 12.4564 2.03984 12.0833 2.50008 12.0833H12.5001ZM17.5001 6.25C17.9603 6.25 18.3334 6.6231 18.3334 7.08333C18.3334 7.54357 17.9603 7.91667 17.5001 7.91667H2.50008C2.03984 7.91667 1.66675 7.54357 1.66675 7.08333C1.66675 6.6231 2.03984 6.25 2.50008 6.25H17.5001Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconShorter: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"shorter"} {...props} />
);
